/* 3Rivers3D theme — small site-wide helpers (no libraries) */
(function () {
  var R3 = window.R3 || {};

  function toast(msg) {
    var t = document.getElementById('r3-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }
  R3.toast = toast;

  R3.updateCartCount = function () {
    return fetch((R3.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  };

  function init() {
    // Reveal-on-scroll
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
      document.querySelectorAll('.rv:not(.in)').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
    }

    // Header toggles (mobile menu + search)
    document.querySelectorAll('[data-toggle]').forEach(function (btn) {
      if (btn._bound) return; btn._bound = true;
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-toggle'));
        if (!target) return;
        var open = target.classList.toggle('open');
        btn.setAttribute('aria-expanded', open);
        var f = open && target.querySelector('input');
        if (f) f.focus();
      });
    });

    // Product tabs on the homepage
    document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
      if (wrap._bound) return; wrap._bound = true;
      var btns = wrap.querySelectorAll('[role="tab"]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) {
            x.setAttribute('aria-selected', x === b);
            var p = document.getElementById(x.getAttribute('aria-controls'));
            if (p) p.hidden = x !== b;
          });
        });
      });
    });

    // Quick add (+) on product cards — single-variant products only
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      if (btn._bound) return; btn._bound = true;
      btn.addEventListener('click', function () {
        btn.disabled = true;
        fetch((R3.routes.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-quick-add'), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error();
          btn.innerHTML = '&#10003;';
          toast('Added to cart');
          return R3.updateCartCount();
        }).catch(function () {
          toast('Sorry — that item could not be added');
        }).finally(function () {
          setTimeout(function () { btn.disabled = false; btn.innerHTML = '+'; }, 1200);
        });
      });
    });

    // Product page: gallery thumbs + quantity steppers + variant price
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      if (t._bound) return; t._bound = true;
      t.addEventListener('click', function () {
        var main = document.getElementById('r3-main-img');
        if (main) { main.src = t.getAttribute('data-thumb'); main.removeAttribute('srcset'); }
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === t); });
      });
    });
    document.querySelectorAll('[data-qty]').forEach(function (q) {
      if (q._bound) return; q._bound = true;
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (+input.value || 1) + (+b.getAttribute('data-step')));
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
    var vjson = document.getElementById('r3-variants');
    var vsel = document.querySelector('[data-variant-select]');
    if (vjson && vsel && !vsel._bound) {
      vsel._bound = true;
      var variants = JSON.parse(vjson.textContent);
      vsel.addEventListener('change', function () {
        var v = variants.find(function (x) { return String(x.id) === vsel.value; });
        if (!v) return;
        document.querySelectorAll('[data-price]').forEach(function (pe) { pe.textContent = v.price_formatted; });
        var ce = document.querySelector('[data-compare]');
        if (ce) { ce.textContent = v.compare_formatted || ''; }
        var rel = document.querySelector('[data-release]');
        document.querySelectorAll('[data-atc]').forEach(function (atc) { atc.disabled = !v.available || (rel && !rel.checked); atc.textContent = v.available ? atc.getAttribute('data-label') : 'Sold out'; });
        if (v.image) { var main = document.getElementById('r3-main-img'); if (main) { main.src = v.image; main.removeAttribute('srcset'); } }
        var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      });
    }
  }

  // Phone: sticky bottom bars appear once the main button scrolls out of view
  function initBars() {
    document.querySelectorAll('[data-m-bar]').forEach(function (bar) {
      if (bar._bound) return; bar._bound = true;
      var target = bar.getAttribute('data-m-bar') === 'atc'
        ? document.querySelector('.buy-row [data-atc]')
        : document.querySelector('[data-m-watch]');
      document.body.classList.add('has-m-bar');
      if (!target || !('IntersectionObserver' in window)) { bar.classList.add('show'); return; }
      new IntersectionObserver(function (es) {
        var hidden = !es[0].isIntersecting;
        bar.classList.toggle('show', hidden);
        bar.setAttribute('aria-hidden', hidden ? 'false' : 'true');
      }).observe(target);
    });
  }
  // Phone: tab-bar Menu opens the full-screen menu right under the header; footer groups fold up
  function initPhone() {
    var mb = document.querySelector('[data-tb-menu]'), mnav = document.getElementById('r3-mnav');
    if (mb && mnav && !mb._bound) {
      mb._bound = true;
      var close = function () { mnav.classList.remove('open'); mb.classList.remove('on'); mb.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; };
      mb.addEventListener('click', function () {
        if (mnav.classList.contains('open')) return close();
        var hdr = document.querySelector('.site-header');
        if (hdr) mnav.style.top = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) + 'px';
        mnav.classList.add('open'); mb.classList.add('on'); mb.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      });
      mnav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    }
    document.querySelectorAll('.foot > div:not(:first-child) h6').forEach(function (h) {
      if (h._bound) return; h._bound = true;
      h.setAttribute('role', 'button'); h.tabIndex = 0;
      var t = function () { h.parentElement.classList.toggle('open'); };
      h.addEventListener('click', t);
      h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t(); } });
    });
  }
  document.addEventListener('DOMContentLoaded', initPhone);
  document.addEventListener('shopify:section:load', initPhone);
  document.addEventListener('DOMContentLoaded', initBars);
  document.addEventListener('shopify:section:load', initBars);
  document.addEventListener('DOMContentLoaded', init);
  // Re-run when sections are edited in the Shopify theme editor
  document.addEventListener('shopify:section:load', init);
  window.R3 = R3;
})();
/* Giveaway countdown + "copy code" buttons */
(function(){
  function tick(){
    document.querySelectorAll('[data-countdown]').forEach(function(el){
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      var sec = el.closest('.give');
      if (!end || isNaN(end)) { el.hidden = true; return; }
      var left = Math.max(0, end - Date.now());
      if (left <= 0 && sec) sec.classList.add('ended');
      var d = Math.floor(left/864e5), h = Math.floor(left/36e5)%24, m = Math.floor(left/6e4)%60, s = Math.floor(left/1e3)%60;
      el.innerHTML = [[d,'Days'],[h,'Hours'],[m,'Min'],[s,'Sec']].map(function(x){ return '<div><b>'+String(x[0]).padStart(2,'0')+'</b><small>'+x[1]+'</small></div>'; }).join('');
    });
  }
  tick(); setInterval(tick, 1000);
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-copy]'); if (!b) return;
    var t = b.getAttribute('data-copy');
    (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function(){ b.textContent = 'Copied!'; }, function(){ b.textContent = 'Press & hold the code to copy'; });
    setTimeout(function(){ b.textContent = 'Copy'; }, 2000);
  });
})();

/* Which email form was just submitted? (newsletter vs giveaway both use Shopify's customer form) */
(function(){
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (f && f.id && /^r3-(newsletter|giveaway)/.test(f.id)) { try { sessionStorage.setItem('r3_last_form', f.id); } catch(_){} }
  }, true);
  document.addEventListener('DOMContentLoaded', function(){
    if (!/customer_posted=true|form_type=customer/.test(location.search + location.hash) && !document.querySelector('[data-success-for]')) return;
    var id = null; try { id = sessionStorage.getItem('r3_last_form'); } catch(_){}
    document.querySelectorAll('[data-success-for]').forEach(function(el){
      var mine = el.getAttribute('data-success-for') === id;
      if (!mine && id) { el.hidden = true; return; }
      var form = document.getElementById(el.getAttribute('data-success-for'));
      if (form && !el.classList.contains('err')) form.querySelectorAll('[data-hide-on-success]').forEach(function(x){ x.hidden = true; });
      if (form) form.scrollIntoView({ block: 'center' });
    });
  });
})();
/* Giveaway banner hides itself after its end date */
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.give-banner[data-ends], .gw[data-ends]').forEach(function(el){
    var t = new Date(el.getAttribute('data-ends')).getTime();
    if (t && !isNaN(t) && Date.now() > t) el.setAttribute('data-ended', 'true');
  });
});
/* Release of Liability: Add to Cart stays locked until the box is checked; the box stays checked */
document.addEventListener('DOMContentLoaded', function () {
  var box = document.querySelector('[data-release]');
  if (!box) return;
  var form = box.form, wrap = box.closest('[data-release-wrap]'), time = form && form.querySelector('[data-release-time]');
  var key = 'r3_release_' + location.pathname;
  try { if (sessionStorage.getItem(key) === '1') box.checked = true; } catch (e) {}
  function sync() {
    var on = box.checked;
    if (wrap) wrap.classList.toggle('ok', on);
    if (time) { time.disabled = !on; if (on && !time.value) time.value = new Date().toLocaleString(); }
    document.querySelectorAll('[data-atc]').forEach(function (b) {
      var soldOut = b.textContent.trim() === 'Sold out';
      b.disabled = !on || soldOut;
      b.title = on ? '' : 'Check the Release of Liability box first';
    });
    try { sessionStorage.setItem(key, on ? '1' : '0'); } catch (e) {}
  }
  box.addEventListener('change', sync);
  window.addEventListener('pageshow', sync);
  if (form) form.addEventListener('submit', function (e) {
    if (!box.checked) { e.preventDefault(); if (wrap) { wrap.classList.remove('nudge'); void wrap.offsetWidth; wrap.classList.add('nudge'); wrap.scrollIntoView({ block: 'center', behavior: 'smooth' }); } }
  });
  // the sticky phone button: if locked, take them to the box instead
  document.querySelectorAll('.m-bar [data-atc]').forEach(function (b) {
    b.parentElement.addEventListener('click', function (e) {
      if (!box.checked && e.target.closest('[data-atc]')) { e.preventDefault(); wrap.scrollIntoView({ block: 'center', behavior: 'smooth' }); wrap.classList.remove('nudge'); void wrap.offsetWidth; wrap.classList.add('nudge'); }
    }, true);
  });
  sync();
});
/* Main banner comes back on its own once the giveaway is over */
(function(){
  function run(){
    document.querySelectorAll('.hero[data-show-after]').forEach(function(h){
      var t = new Date(h.getAttribute('data-show-after')).getTime();
      if (!t || isNaN(t) || Date.now() > t) h.classList.add('is-live');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
/* Product options: swatch + pill pickers drive the hidden variant select */
(function(){
  var NAMED = { black:'#151515', charcoal:'#33373d', gray:'#8a8f98', grey:'#8a8f98', silver:'#c7ccd1', white:'#f5f5f0', blue:'#1f6bff', navy:'#1e2f6b',
    'electric blue':'#1f6bff', 'sky blue':'#5bb7e6', red:'#d92b2b', orange:'#f97316', yellow:'#eab308', green:'#16a34a', 'od green':'#5b6236', 'army green':'#5b6236',
    tan:'#c8a97e', brown:'#6b4423', purple:'#7c3aed', pink:'#ec4899', clear:'#cfe8f0', natural:'#ece6d8', 'carbon fiber':'#2b2f36', camo:'#5b6236' };
  function colorFor(v){
    var k = String(v).toLowerCase().trim();
    if (NAMED[k]) return NAMED[k];
    var c = k.replace(/\s+/g, '');
    return (window.CSS && CSS.supports && CSS.supports('color', c)) ? c : null;
  }
  function init(){
    var root = document.querySelector('[data-opt-root]'); if (!root || root._bound) return; root._bound = true;
    var vjson = document.getElementById('r3-variants'), sel = document.querySelector('[data-variant-select]');
    if (!vjson || !sel) return;
    var variants = JSON.parse(vjson.textContent);
    var groups = [].slice.call(root.querySelectorAll('.opt-group'));
    // colour swatches: use Shopify's swatch colour if set, else match the name
    root.querySelectorAll('.opt-pills.is-color .opt-pill').forEach(function(p){
      var sw = p.querySelector('.sw'); if (!sw || sw.style.getPropertyValue('--sw')) return;
      var c = colorFor(p.querySelector('input').value);
      if (c) sw.style.setProperty('--sw', c); else { p.closest('.opt-pills').classList.remove('is-color'); }
    });
    function chosen(){ return groups.map(function(g){ var i = g.querySelector('input:checked'); return i ? i.value : null; }); }
    function match(opts){ return variants.find(function(v){ return v.options.every(function(o, i){ return opts[i] == null || o === opts[i]; }); }); }
    function refresh(){
      var opts = chosen();
      groups.forEach(function(g, gi){
        var lab = g.querySelector('[data-opt-selected]'); if (lab) lab.textContent = opts[gi] || '';
        g.querySelectorAll('.opt-pill').forEach(function(p){
          var test = opts.slice(); test[gi] = p.querySelector('input').value;
          var v = variants.find(function(x){ return x.options.every(function(o, i){ return o === test[i]; }); });
          p.classList.toggle('unavail', !v || !v.available);
        });
      });
      var v = match(opts);
      if (v && String(sel.value) !== String(v.id)) { sel.value = v.id; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    root.addEventListener('change', refresh);
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
